/*
 * @Author: Tina Huang
 * @Date: 2024-01-23 12:27:50
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-10-23 14:54:45
 * @Description:
 */
// import { NextUIProvider } from "@nextui-org/react"
import { metadata } from '../App'
import { Layout, Menu, Button, Image, Space, FloatButton, Popover, Modal, Tag, Avatar, Badge, Tooltip } from 'antd'
import React, { useEffect, useState, useRef } from 'react'
import ToUseButton from './ToUseButton'
import { NAV_MENU, HOME_NAV } from '../constants/navs'
import { news } from '@/constants/notifies'
import { logs } from '@/constants/logs'
import { useNavigate } from 'react-router-dom'
import { QuestionCircleOutlined, ArrowUpOutlined, SendOutlined } from '@ant-design/icons'
import NewItem from '@/pages/News/item'
import { checkVIP } from '@/utils'
import Help from './Help'

const { Header, Content, Footer } = Layout

let scrollToptimer: any

export default function MyLayout(props: { children: any; location?: string }) {
  const { children, location } = props
  const { title } = metadata
  const [home, setHome] = useState<Boolean>(false)
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState<any[]>([])
  const [showNews, setShowNews] = useState(false)
  const navigate = useNavigate()
  const isMobile = window.innerWidth <= 750
  const lastedNew = news.filter((item) => item.show && item.type !== 'top')[0]
  const lastedLog = logs[0]
  const bindModalRef = useRef({
    open: false,
  })

  useEffect(() => {
    return () => {
      scrollToptimer && clearInterval(scrollToptimer)
    }
  }, [])

  useEffect(() => {
    const _home = window.location.hash === '' || window.location.hash === '#/'
    setHome(_home)
    setDefaultSelectedKeys([location])
  }, [location])

  useEffect(() => {
    // ! 在模版领取页面则不显示弹窗
    if (window.location.hash.indexOf('get-template/') > -1) {
      console.log('不显示信息弹窗')
      return setShowNews(false)
    }
    if (!lastedNew) return setShowNews(false)
    const showUpdate = localStorage.update
    if (!showUpdate || lastedNew?.datetime !== showUpdate) {
      console.log('show')
      localStorage.update = lastedNew.datetime
      setShowNews(true)
    }
    window.bindModalRef = bindModalRef
  }, [lastedNew])

  const VipInfo = (): JSX.Element => {
    if (isMobile) return <></>
    const _member = checkVIP()
    if (_member) {
      const _nick = _member?.nickname
      return (
        <div className="flex items-center">
          <Badge count={<span>👑</span>} style={{ right: -5, top: -2, transform: 'rotate(15deg)' }}>
            <Avatar style={{ backgroundColor: '#f56a00' }}>{_nick?.substring(0, 2)}</Avatar>
          </Badge>
          <span className="ml-2">{_nick}</span>
        </div>
      )
    }
    return <></>
  }

  const headerStyle: React.CSSProperties = {
    textAlign: 'center',
    color: '#333',
    height: 64,
    paddingInline: 18,
    lineHeight: '64px',
    backgroundColor: '#fff',
    position: 'fixed',
    width: '100%',
    right: 0,
    zIndex: 99,
    borderBottom: '1px solid #f3f3f3',
  }

  const contentStyle: React.CSSProperties = {
    marginTop: 64,
    boxSizing: 'border-box',
    width: '100%',
    overflowX: 'hidden',
    backgroundColor: home ? '#ffffff' : '#f3f3f3',
  }

  const handleYearlyPlanner = () => {
    navigate('/picks-detail/86')
  }

  const handleMenuClick = (path: any) => {
    if (path?.indexOf('http') > -1) return window.open(path)
    navigate(path)
  }
  const handleUpdateDialog = () => {
    if (lastedNew.page) {
      navigate(lastedNew.page?.name)
    }
    setShowNews(false)
  }
  const handleReturnTop = () => {
    scrollToptimer = setInterval(function () {
      console.log('定时循环回到顶部')
      var top = document.body.scrollTop || document.documentElement.scrollTop
      var speed = top / 4
      if (document.body.scrollTop !== 0) {
        document.body.scrollTop -= speed
      } else {
        document.documentElement.scrollTop -= speed
      }
      if (top === 0) {
        clearInterval(scrollToptimer)
      }
    }, 30)
  }

  const MenuItem = (props: { item: any; icon: boolean }) =>
    props.item.key === 'picks' && home ? (
      <Tooltip
        open={true}
        title={
          <div className="relative cursor-pointer" onClick={handleYearlyPlanner}>
            <span className="text-5xl absolute -left-4 -top-4">🎉 </span>
            <span className="pl-10">2025年度计划，开启试用</span>
          </div>
        }
      >
        <Button type="text" onClick={() => handleMenuClick(props.item.path)}>
          {props.icon ? props.item.logo : <></>} {props.item.name}
        </Button>
      </Tooltip>
    ) : (
      <Button type="text" onClick={() => handleMenuClick(props.item.path)}>
        {props.icon ? props.item.logo : <></>} {props.item.name}
      </Button>
    )

  const menuItems = home
    ? HOME_NAV.map((item) => ({
        key: item.key,
        label: <MenuItem item={item} icon={true} />,
      }))
    : NAV_MENU.map((item) => ({
        key: item.key,
        label: <MenuItem item={item} icon={false} />,
      }))

  return (
    <Layout>
      <Header style={headerStyle}>
        <div className="flex w-full justify-around items-center">
          <Button type="link" href={process.env.PUBLIC_URL} className="text-black flex items-center">
            <Image src="icon-1.png" alt="logo" width={30} className="mr-10" />
            <span className="font-bold text-inherit text-black">
              {title?.toString()}
              <Tag color="blue" className="ml-2">
                {lastedLog.version}
              </Tag>
            </span>
          </Button>
          {/* <div className="hidden xl:block gap-6">动动手个性化自定义你的组件吧</div> */}
          <Menu
            className="w-1/2"
            theme="light"
            mode="horizontal"
            items={menuItems}
            defaultOpenKeys={['libs', 'vips', 'likes']}
            selectedKeys={defaultSelectedKeys}
          />
          <ToUseButton hide={isMobile} />
          <VipInfo />
        </div>
      </Header>
      <Content style={contentStyle} className="min-h-screen">
        {children}
      </Content>
      <Footer className="text-center text-gray-400 p-3 flex justify-center">
        <FloatButton icon={<ArrowUpOutlined />} style={{ right: 24, bottom: 110 }} onClick={handleReturnTop} />
        <Help />
        <Space>
          <span>© 2024 HTTISHERE · 阿汪同学个人所有</span>
          {!isMobile && (
            <>
              |
              <span>
                联系：
                <a href="mailto:httishere0728@gmail.com" title="邮件">
                  httishere0728@gmail.com
                </a>
              </span>
              |
              <span>
                小红书：
                <a
                  target="blank"
                  href="https://www.xiaohongshu.com/user/profile/5c049fc9000000000800af53?xhsshare=WeixinSession&appuid=5c049fc9000000000800af53&apptime=1664074455"
                >
                  @肥汪卷
                </a>
              </span>
              |
              <span>
                B站：
                <a href="https://space.bilibili.com/19225439?spm_id_from=333.1007.0.0" target="blank">
                  @阿汪同学
                </a>
              </span>
              |
              <span>
                微信公众号：<span>汪汪汪世界</span>
              </span>
            </>
          )}
        </Space>
      </Footer>
      <Modal
        open={showNews}
        onCancel={() => setShowNews(false)}
        footer={
          <>
            <Button type="primary" shape="round" className="m-auto block" onClick={handleUpdateDialog}>
              {lastedNew?.btnText || '立即体验'}
            </Button>
          </>
        }
      >
        <NewItem item={lastedNew} />
      </Modal>
    </Layout>
  )
}
